var map = {
	"./CantinettaFiveW255.png": 83199,
	"./CantinettaOneW255.png": 66037,
	"./CantinettaThreeW255.png": 28693,
	"./CantinettaTwoW255.png": 82415,
	"./armadiettoW255.png": 83640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72332;